module.exports = __webpack_public_path__ + "img/scan.16b6457b.svg";